import { render, staticRenderFns } from "./ManageStage.vue?vue&type=template&id=7e04a5c1&scoped=true&"
import script from "./ManageStage.vue?vue&type=script&lang=js&"
export * from "./ManageStage.vue?vue&type=script&lang=js&"
import style0 from "./ManageStage.vue?vue&type=style&index=0&id=7e04a5c1&prod&scoped=true&lang=css&"
import style1 from "./ManageStage.vue?vue&type=style&index=1&id=7e04a5c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e04a5c1",
  null
  
)

export default component.exports